export const getCurrentEnv: string = process.env.REACT_APP_CONFIG_STATE!;